import type { RootState } from "@/app/store";

export const selectNickCar = (state: RootState) => state.nickCar;
export const selectNextNickTime = (state: RootState) =>
  state.nickCar.nextNickTime;
export const selectIsNickingCar = (state: RootState) =>
  state.nickCar.isNickingCar;
